export default [
  {
    title: "Exceptions",
    icon: "XIcon",
    route: "ExceptionReport-View",
    resource: "Report",
    action: "ExceptionReport",
    children: [
      {
        title: "Exception Transaction",
        route: "ExceptionReport-View",
        resource: "Report",
        action: "ExceptionReport",
      },
      {
        title: "Manual Transaction",
        route: "ManualTransaction-View",
        resource: "Report",
        action: "ManualTransaction",
      },
      {
        title: "Error Response",
        route: "MerchantResponseGroup-View",
        resource: "Report",
        action: "MerchantResponseGroup",
      },
      {
        title: "Partner Attempt",
        icon: "MonitorIcon",
        children: [
          {
            title: "Payment",
            route: "PartnerAttemptPayment-View",
            resource: "Report",
            action: "PartnerAttempt",
          },
          {
            title: "Refund",
            route: "PartnerAttemptRefund-View",
            resource: "Report",
            action: "PartnerAttempt",
          },
        ],
      },
      {
        title: "Duplicate Transaction",
        route: "DuplicateTransaction-View",
        resource: "Report",
        action: "DuplicateTransaction",
      },
    ],
  },
];
